<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 공표기간 -->
          <c-datepicker
            :range="true"
            defaultStart="-2y"
            defaultEnd="2M"
            label="LBL0010076"
            name="promulgationPeriod"
            v-model="searchParam.promulgationPeriod"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 진행단계 -->
          <c-select
            type="search"
            stepperGrpCd="MDM_LAW_STEP_CD"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="mdmLawStepCd"
            label="LBLSTEPPROGRESS"
            v-model="searchParam.mdmLawStepCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 검토자 -->
          <c-field
            label="LBLREVIEWER"
            name="checkUserId"
            v-model="searchParam.checkUserId" />
        </div>
      </template>
    </c-search-box>
    <!--법령검토 목록-->
    <c-table
      title="ESF 법규검토 목록"
      tableId="lawMakingCheck"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!-- 등록 -->
          <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="openPop" /> 
          <!-- 검색 -->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="props.row.lawLink">
          <q-btn
            class="tableinnerBtn"
            flat
            icon="launch"
            align="center"
            color="blue-6"
            label=""
            @click.stop="linkClick(props.row, col)" />
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'law-review',
  data() {
    return {
      searchParam: {
        promulgationPeriod: [],
        mdmLawStepCd: null,
        checkUserId: '',
      },
      grid: {
        columns: [
          {
            name: 'mdmLawStepName',
            field: 'mdmLawStepName',
            //진행단계
            label: 'LBLSTEPPROGRESS',
            align: 'center',
            sortable: false,
            style: 'width:80px',
            type: 'link',
          },
          {
            name: 'acceptDeptNames',
            field: 'acceptDeptNames',
            //적용부서
            label: 'LBL0010078',
            align: 'left',
            sortable: false,
            style: 'width:130px',
          },
          {
            name: 'checkUserNames',
            field: 'checkUserNames',
            //검토자
            label: 'LBLREVIEWER',
            align: 'left',
            sortable: false,
            style: 'width:130px',
          },
          {
            name: 'lawNameKor',
            field: 'lawNameKor',
            //법령명한글
            label: 'LBL0010079',
            align: 'center',
            sortable: false,
            style: 'width:120px',
          },
          {
            name: 'lawNameAbb',
            field: 'lawNameAbb',
            //법령약칭명
            label: 'LBL0010080',
            align: 'center',
            sortable: false,
            style: 'width:100px',
          },
          {
            name: 'promulgationDate',
            field: 'promulgationDate',
            //공포일자
            label: 'LBL0010081',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          {
            name: 'revisiontypename',
            field: 'revisiontypename',
            //제개정
            label: 'LBL0010082',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          {
            name: 'competentMinistriesName',
            field: 'competentMinistriesName',
            //소관부처
            label: 'LBL0010083',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          {
            name: 'lawClassName',
            field: 'lawClassName',
            //법령구분
            label: 'LBL0010084',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          {
            name: 'enforcementDate',
            field: 'enforcementDate',
            //시행일자
            label: 'LBL0010085',
            align: 'center',
            sortable: false,
            style: 'width:80px',
          },
          // {
          //   name: 'lawTypeFlag',
          //   field: 'lawTypeFlag',
          //   label: '자법타법여부',
          //   align: 'center',
          //   sortable: false,
          //   style: 'width:80px',
          // },
          {
            name: 'custom',
            field: 'custom',
            //법령상세링크
            label: 'LBL0010086',
            align: 'center',
            sortable: false,
            style: 'width:80px',
            type: 'custom'
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sai.lawCheck.check.list.url
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col) {
      if (col.name === 'mdmLawStepName') {
        this.openPop(row)
      } else if (col.name === 'custom') {
        window.open('http://www.law.go.kr' + row.lawLink, '법규', 'width=1200, height=700');
      }
    },
    openPop(row) {
      this.popupOptions.title = 'ESF 법규검토';  //법령 검토
      this.popupOptions.param = {
        mdmLawCheckId: row ? row.mdmLawCheckId : '',
      };
      this.popupOptions.target = () => import(`${'./lawReviewDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
